"use strict";
import fetch from '@elements/fetch';
import formDataEntries from 'form-data-entries';

export function initInScope ($scope) {
    $scope.find('.js-add-promotion').on('submit', function (e) {
        e.preventDefault();

        let url = $(this).attr('action');
        let $message = $scope.find('.js-add-promotion__message');
        let pendingRequest;

        if(pendingRequest){
            pendingRequest.abort();
            pendingRequest = null;
        }

        let body = new URLSearchParams(formDataEntries($(this)[0]));

        pendingRequest = fetch(url, {
            method: 'POST',
            body: body
        });

        pendingRequest.then((res) => {
            return res.clone().json()
        }).then((res) => {
            console.log(res);
            if(res.success){
                if(res.redirectToCart){
                    window.location.href = res.redirect.targetUrl;
                } else {
                    $message.html(res.message.content);
                    $('html, body').stop().animate({
                        scrollTop: $message.offset().top - 180
                    }, 500, 'swing');
                }
            } else {
                console.log('NO');
            }
        });

    });
}